/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Orders_Ready_QuestionInputs */

const en_orders_ready_question = /** @type {(inputs: Orders_Ready_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ready?`)
};

const es_orders_ready_question = /** @type {(inputs: Orders_Ready_QuestionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listo?`)
};

/**
* | output |
* | --- |
* | "Ready?" |
*
* @param {Orders_Ready_QuestionInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const orders_ready_question = /** @type {((inputs?: Orders_Ready_QuestionInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Orders_Ready_QuestionInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_orders_ready_question(inputs)
	return es_orders_ready_question(inputs)
});